import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * affiliate-lookup operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const lookupAffiliate = async ({
  request,
}: {
  request: ApiTypes["affiliate-lookup"]["request"];
}): Promise<ApiTypes["affiliate-lookup"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["affiliate-lookup"]["response"]
    >(`/api/public/v2025-06/affiliates/lookup`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to lookupAffiliate");
    throw error;
  }
};
